import { isDefined } from "@clipboard-health/util-ts";
import { isCapacitorPlatform, useAppInfo } from "@src/appV2/lib/index";
import {
  HcfTimeclockComplianceRolloutState,
  type HcfTimeclockComplianceVideoValidationRollout,
} from "@src/appV2/Shifts/Shift/ShiftState/types";
import { isEnabledForAppVersionAndOta } from "@src/appV2/Shifts/utils/isSolveUnpaidBreaksFeatureEnabled";

export function useIsTimeclockComplianceVideoValidationEnabled(
  hcfTimeclockComplianceVideoValidationRollout?: HcfTimeclockComplianceVideoValidationRollout
): boolean {
  const { appInfo } = useAppInfo();

  if (!isDefined(hcfTimeclockComplianceVideoValidationRollout)) {
    return false;
  }

  const { state, minimalOtaVersion, minimalStoreVersion } =
    hcfTimeclockComplianceVideoValidationRollout;

  if (state !== HcfTimeclockComplianceRolloutState.ENABLED) {
    return false;
  }

  // on web, no need to check version
  if (!isCapacitorPlatform()) {
    return true;
  }

  // if appInfo is not loaded, we can't check version
  if (!isDefined(appInfo)) {
    return false;
  }

  // if version is too low, return false
  try {
    if (
      !isEnabledForAppVersionAndOta({
        minimalOtaVersion: String(minimalOtaVersion),
        minimalStoreVersion,
        appInfo,
      })
    ) {
      return false;
    }
  } catch {
    return false;
  }

  return true;
}
